import React from 'react';
import ZoomContext from '../ZoomContext';

export default function ZoomProvider(props) {
  const { value, children } = props;
  return <ZoomContext.Provider value={value}>{children}</ZoomContext.Provider>;
}
